module.exports = __webpack_public_path__ + "img/info.b4343f9f.svg";